<template>
  <div class="mb-5">
    <!-- Modal Upload de fotos e documentos -->
    <div style="z-index: 1000" :title="this.titleModalUpload">
      <div v-if="!listArquivos.length" class="m-5 mb-10">
        <h5>Não há arquivos selecionados</h5>
      </div>
      <div v-else class="flex flex-wrap">
        <div
          v-for="(arquivo, index) in listArquivos"
          :key="index"
          class="md:w-1/2 w-full p-5"
        >
          <vs-card>
            <div class="flex justify-between items-center">
              <a
                target="_blank"
                class="text-lg"
                :href="arquivo.url"
                rel="noopener noreferer"
              >
                {{ arquivo.nome }}
              </a>
              <vs-button
                v-tooltip="'Deletar arquivo'"
                type="gradient"
                color="danger"
                icon="close"
                size="small"
                class="mb-2"
                @click="deleteArquivoUpload(index)"
              ></vs-button>
            </div>
          </vs-card>
        </div>
      </div>
      <div v-if="listArquivos.length >= 40" class="mb-3">
        <vs-alert title="Atenção" active="true" color="danger">
          <span v-if="listArquivos.length"
            >Você já possui {{ listArquivos.length }} fotos salvas.</span
          >
          <span v-if="listArquivos.length === 40">
            Para adicionar novos arquivos, exclua um arquivo da sua lista
            anterior
          </span>
          <span v-if="listArquivos.length > 40">
            O limite de upload é de 40 arquivos, exclua um arquivo da sua lista
            para subir novamente
          </span>
        </vs-alert>
      </div>

      <!-- Footer -->
      <div class="flex justify-end gap-5">
        <vs-button
          @click="openEscolhaArquivoUpload()"
          :disabled="listArquivos.length >= 40"
          color="warning"
        >
          <div class="flex items-center gap-2">
            <feather-icon icon="PlusIcon" />Escolher arquivos
          </div></vs-button
        >
        <input
          :id="`fileUploadAnexoRelacionamento`"
          type="file"
          accept="image/*,.pdf"
          @change="selectArquivoUpload"
          name="files"
          multiple
          enctype="multipart/form-data"
          hidden
        />
        <vs-button
          @click="uploadArquivosSelecionados()"
          :disabled="listArquivos.length > 40 || listArquivos.length < 1"
        >
          <div class="flex items-center gap-2">
            <feather-icon icon="UploadIcon" />Salvar:
            {{ listArquivos.length }} arquivos selecionados
          </div></vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
import functions from '../../utils/functions';

export default {
  props: {
    dadosRelacionamento: Object,
    arquivos: Array,
    modalUploadAtivo: Boolean,
    title: {
      type: String,
      default: 'Cadastrar Fotos e Documentos',
    },
  },
  data() {
    return {
      showComponent: true,
      idUsuario: null,
      modalFotoAtivo: false,
      titleModalUpload: null,
      itemModalSelecionado: null,
      listArquivosToDelete: [],
      listArquivos: [],
      files: [],
      idTerceiro: null,
      idRelacionamento: null,
      formCadastro: {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculo: null,
        idVeiculos: null,
        url: null,
        uploadedBy: null,
        ip: null,
        observacao: null,
      },
    };
  },
  methods: {
    openEscolhaArquivoUpload() {
      document.getElementById(`fileUploadAnexoRelacionamento`).click();
    },
    selectArquivoUpload(event) {
      const fileList = event.target.files || event.dataTransfer.files;

      if (!fileList.length) {
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        this.listArquivos.push({
          legenda: this.getNomeArquivoSemExtensao(file.name),
          url: URL.createObjectURL(file),
          nome: file.name,
          size: file.size,
          type: file.type,
          ip: this.formCadastro.ip,
          updatedAt: dayjs().format('DD/MM/YYYY HH:mm:ss'),
        });
        this.files.push(file);
      }
    },

    deleteArquivoUpload(index) {
      this.listArquivos.splice(index, 1);

      const deletedFile = this.listArquivos[index];
      const fileIndex = this.files.findIndex(
        (file) => file.name === deletedFile.nome,
      );

      if (fileIndex !== -1) {
        this.files.splice(fileIndex, 1);
      }
    },
    getNomeArquivoSemExtensao(nomeArquivo) {
      const ultimoPontoIndex = nomeArquivo.lastIndexOf('.');

      if (ultimoPontoIndex !== -1) {
        return nomeArquivo.substring(0, ultimoPontoIndex);
      }

      return nomeArquivo;
    },
    isPdf(urlArquivo) {
      if (!urlArquivo) return false;

      const ext = urlArquivo.split('.').pop();

      return ext === 'pdf';
    },
    async uploadArquivosSelecionados() {
      this.$emit('dataChanged', this.files);
      this.listArquivos = [];
      this.files = [];
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const decoded = jwt.decode(token);
        this.idUsuario = decoded.id_usuario;
      }
    },
  },
  async mounted() {
    this.getDecoded();
    this.formCadastro.ip = await functions.getIP();
  },
};
</script>

<style>
.colorBlue {
  color: #00bfed;
}

.remove {
  background-color: rgb(252 165 165);
  color: black;
}
</style>
